/* tslint:disable:align */
//============================================================================
// Name        : ItemUsage.tsx
// Purpose     : Implement Customer Item Usage report
// Created     : 2020-02-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import moment from "moment";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import React from "react";
import Checkbox from "../controls/Checkbox";

interface IItemUsageProps {
    enabled: boolean;
    recepientEmails: string;
    startTime: string;
    customerName: string;
    filterByLastSeen: boolean;
    lastSeenValue: string;
    itemList: string;
    reportSaveUrl: string;
    generateReportUrl: string;
}

interface IItemUsageState {
    enabled: boolean;
    recepientEmails: string;
    startTime: string;
    customerName: string;
    filterByLastSeen: boolean;
    lastSeenValue: string;
    itemList: string;
}

export default class ItemUsage extends React.Component<IItemUsageProps, IItemUsageState> {
    constructor(props: any) {
        super(props);

        // Set state from props
        this.state = this.props;
    }

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newState: Partial<IItemUsageState> = { [event.target.name]: event.target.value };
        this.setState(newState as IItemUsageState);
    }

    onTextAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newState: Partial<IItemUsageState> = { [event.target.name]: event.target.value };
        this.setState(newState as IItemUsageState);
    }

    onCheckboxChange = (name: string, checked: boolean) => {
        const newState: Partial<IItemUsageState> = { [name]: checked };
        this.setState(newState as IItemUsageState);
    }

    render() {
        const defaultDate = moment(this.state.startTime, "H:mm a");
        return (
            <form action={this.props.reportSaveUrl}>
                <div className="form-group">
                    <Checkbox name="enabled" label="Report enabled" checked={this.props.enabled} onChange={this.onCheckboxChange} />
                </div>

                <div className="form-group">
                    <label><b>Report Recepients Email List</b></label>
                    <textarea name="recepientEmails" value={this.state.recepientEmails} onChange={this.onTextAreaChange} className="form-control" cols={50} rows={3}></textarea>
                </div>

                <div className="form-group">
                    <label><b>Scheduled Time</b></label>
                    <div>
                        <TimePicker name="startTime" defaultValue={defaultDate} placeholder="Click to Select Time" showSecond={false} minuteStep={5} use12Hours />
                    </div>
                </div>

                <div className="form-group">
                    <label><b>Customer Name</b></label>
                    <input type="text" name="customerName" value={this.state.customerName} onChange={this.onChange} className="form-control"/>
                </div>

                <div className="form-group">
                    <div>
                        <label><b>Filter report</b></label>
                    </div>

                    <div className="inline-flex" css={{ alignItems: "center", width: "100%" }}>
                        <Checkbox name="filterByLastSeen" label="Filter by items seen in the last" checked={this.props.filterByLastSeen} onChange={this.onCheckboxChange} />
                        <input type="number" pattern="[0-9]+([\.,][0-9]+)?" name="lastSeenValue" value={this.state.lastSeenValue} onChange={this.onChange} className="form-control"
                               css={{ display: "inline", width: "60px", marginLeft: "15px", marginRight: "15px" }}/>
                        <span>Days</span>
                    </div>
                </div>

                <hr/>
                <div className="form-group">
                    <button type="submit" className="btn btn-primary">
                        Save Report Settings
                    </button>
                    <a href={this.props.generateReportUrl} className="btn btn-default mgnleft-10px">
                        Generate & Email Report
                    </a>
                </div>

                <div className="form-group">
                    <label><b>Item Numbers</b></label>
                    <textarea name="itemList" value={this.state.itemList} onChange={this.onTextAreaChange} className="form-control" cols={50} rows={10}></textarea>
                </div>
            </form>
        );
    }
}
